import React from 'react';

import PropTypes from 'prop-types';
import {
  TableBody,
  TableRow,
  TableCell,
  Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';
import useTable from '../components/useTable';
import DeleteSiteButton from '../content/DeleteSiteButton';
import EditSiteButton from '../content/EditSiteButton';
import generateIntakePlanLabel from '../utils/generateIntakePlanLabel';

const header = [
  { id: 'name', label: 'SITE NAME' },
  { id: 'id', label: 'SITE ID' },
  { id: 'intakePlans', label: 'INTAKE PLAN' },
  { id: 'action', label: '' },
];

export default function SiteInfoTable(props) {
  const {
    isAdmin,
    data,
    refreshParent,
    setSuccessMessage,
    setErrorMessage,
  } = props;

  const {
    TblContainer,
    TblHead,
    TblPagination,
    currentPageDataSorted,
  } = useTable(data, header, { fn: (items) => items });

  return (
    <>
      <TblContainer>
        <TblHead />
        <TableBody>
          {data && currentPageDataSorted().map((row) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>
                <MuiLink component={Link} to={isAdmin ? `/site/${row.id}` : `/site/${row.id}/${row.name}/users`} data-testid="siteName" sx={{ color: 'inherit' }}>
                  {row.name}
                </MuiLink>
              </TableCell>
              <TableCell>{row.id}</TableCell>
              <TableCell>
                {row?.intakePlans === '*' ? 'ALL PLANS' : row?.intakePlans?.map((plan) => (
                  plan ? (
                    <div key={plan.referenceCode}>
                      {generateIntakePlanLabel(plan)}
                    </div>
                  ) : (
                    <div>***AN INTAKE PLAN WAS NOT FOUND (likely deleted in c2i) ***</div>
                  )
                ))}
              </TableCell>
              <TableCell>
                <EditSiteButton
                  site={row}
                  refreshParent={refreshParent}
                  setSuccessMessage={setSuccessMessage}
                  setErrorMessage={setErrorMessage}
                />
                <DeleteSiteButton
                  site={row}
                  refreshParent={refreshParent}
                  setSuccessMessage={setSuccessMessage}
                  setErrorMessage={setErrorMessage}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TblContainer>
      <TblPagination />
    </>
  );
}

SiteInfoTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  refreshParent: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};
